export enum DistributionStatusEnum {
  Signed = 0,
  NotSigned = 1,
  Pending = 2,
  Cancelled = 3,
}
